import { Box } from '@grupoboticario/flora-react'

import BrandsField from '@/components/EventSiteDisplay/BrandsField'
import PeriodField from '@/components/EventSiteDisplay/PeriodField'
import { eventSiteDisplayBoxStyle } from '@/components/EventSiteDisplay/styles'

const EventSiteDisplay = ({ values, setFieldValue, isNewEvent, isReadOnly }) => {
  return (
    <Box css={eventSiteDisplayBoxStyle}>
      <BrandsField isNewEvent={isNewEvent} isReadOnly={isReadOnly} setFieldValue={setFieldValue} values={values} />
      <PeriodField {...{ values, setFieldValue, isReadOnly }} />
    </Box>
  )
}

export default EventSiteDisplay
